import {
  LIST_ROUTE_NAMES,
  PROFILE_ROUTE_NAMES,
  ROUTE_UI_SECTION_NAME,
  WEBAPP_SEARCH_ENTITY,
} from '../../../constants/route'
import { BuildingSearchItem } from '../../Building'
import { EmailSearchItem } from '../../Email'
import { FlatSearchItem } from '../../Flat'
import { PostSearchItem } from '../../Post'
import { ProviderSearchItem } from '../../Provider'
import { RequestSearchItem } from '../../Request'
import { UserSearchItem } from '../../User'

import {
  getBuildings,
  getContractors,
  getEmails,
  getFlats,
  getPosts,
  getRequests,
  getUsers,
} from './LayoutSearch.api'

/**
 * @type {SearchType}
 */
export const SEARCH_BUILDINGS_TYPE = {
  links: {
    item: item => PROFILE_ROUTE_NAMES.building(item.id),
    page: search =>
      LIST_ROUTE_NAMES.searchResultsBuildings({
        archived: search.archived,
        query: search.text,
      }),
  },
  sectionName: ROUTE_UI_SECTION_NAME.buildingsSearch,
  title: 'BuildingTable.PageTitleKey',
  webappEntity: WEBAPP_SEARCH_ENTITY.buildings,
}

/**
 * @type {SearchConfig<object>}
 */
export const SEARCH_BUILDINGS_CONFIG = {
  Component: BuildingSearchItem,
  getItems: getBuildings,
}

/**
 * @type {SearchType}
 */
export const SEARCH_CONTRACTORS_TYPE = {
  links: {
    item: item => PROFILE_ROUTE_NAMES.provider({ id: item.id }),
    page: search =>
      LIST_ROUTE_NAMES.searchResultsProviders({
        archived: search.archived,
        query: search.text,
      }),
  },
  title: 'Providers.PageTitleKey',
}

/**
 * @type {SearchConfig<object>}
 */
export const SEARCH_CONTRACTORS_CONFIG = {
  Component: ProviderSearchItem,
  getItems: getContractors,
}

/**
 * @type {SearchConfig<object>}
 */
export const SEARCH_EMAILS_CONFIG = {
  Component: EmailSearchItem,
  getItems: getEmails,
}

/**
 * @type {SearchType}
 */
export const SEARCH_FLATS_TYPE = {
  links: {
    item: item => PROFILE_ROUTE_NAMES.flat(item.id),
    page: search =>
      LIST_ROUTE_NAMES.searchResultsFlats({
        archived: search.archived,
        query: search.text,
      }),
  },
  sectionName: ROUTE_UI_SECTION_NAME.flatsSearch,
  title: 'FlatTable.PageTitleKey',
  webappEntity: WEBAPP_SEARCH_ENTITY.flats,
}

/**
 * @type {SearchConfig<object>}
 */
export const SEARCH_FLATS_CONFIG = {
  Component: FlatSearchItem,
  getItems: getFlats,
}

/**
 * @type {SearchType}
 */
export const SEARCH_POSTS_TYPE = {
  links: {
    item: item => PROFILE_ROUTE_NAMES.post(item.uuid),
    page: search => LIST_ROUTE_NAMES.searchResultsPosts({ query: search.text }),
  },
  sectionName: ROUTE_UI_SECTION_NAME.newsboardSearch,
  title: 'PostList.PageTitleKey',
  webappEntity: WEBAPP_SEARCH_ENTITY.newsboard,
}

/**
 * @type {SearchConfig<object>}
 */
export const SEARCH_POSTS_CONFIG = {
  Component: PostSearchItem,
  getItems: getPosts,
}

/**
 * @type {SearchConfig<object>}
 */
export const SEARCH_REQUESTS_CONFIG = {
  Component: RequestSearchItem,
  getItems: getRequests,
}

/**
 * @type {SearchType}
 */
export const SEARCH_USERS_TYPE = {
  links: {
    item: item => PROFILE_ROUTE_NAMES.inhabitant({ id: item.id }),
    page: search =>
      LIST_ROUTE_NAMES.searchResultsInhabitants({
        archived: search.archived,
        query: search.text,
      }),
  },
  sectionName: ROUTE_UI_SECTION_NAME.inhabitantsSearch,
  title: 'InhabitantTable.PageTitleKey',
  webappEntity: WEBAPP_SEARCH_ENTITY.inhabitants,
}

/**
 * @type {SearchConfig<object>}
 */
export const SEARCH_USERS_CONFIG = {
  Component: UserSearchItem,
  getItems: getUsers,
}
